/**
 * Validate the update categories parameters
 * @param rowKeys of the rows to be categorized
 * @param categoriesToAdd the categories to be added to the conversations
 * @param categoriesToRemove the categories to be removed from the conversations
 * @param clearCategories whether to clear categories
 */
export default function validateCategoryParameters(
    rowKeys: string[],
    categoriesToAdd: string[],
    categoriesToRemove: string[],
    clearCategories: boolean
) {
    if (!rowKeys || rowKeys.length === 0) {
        throw new Error('Update category action should not be exposed.');
    }

    if (clearCategories && (!!categoriesToAdd || !!categoriesToRemove)) {
        throw new Error(
            'When clearCategories is true, categoriesToAdd and categoriesToRemove both have to be null.'
        );
    }

    if (!!categoriesToAdd && !!categoriesToRemove) {
        throw new Error('Can only add or remove categories at one time.');
    }
}
